import React from 'react';
import { Control } from 'react-hook-form';
import DeviceFiltersSection from './DeviceFiltersSection';
import StatusFiltersSection from './StatusFiltersSection';
import SoftwareFilterSection from './SoftwareFilterSection';
import IncludeDevicesSection from './IncludeDevicesSection';
import ExcludeDevicesSection from '~/features/devices/components/deviceFilters/ExcludeDevicesSection';
import OtherFiltersSection from '~/features/devices/components/deviceFilters/OtherFiltersSection';
import FavoritesSection from './FavoritesSection';
import { ComponentRegistryProvider, useComponentRegistry } from './ComponentRegistryContext';
import { SECTION_IDS } from '~/features/devices/constants/filterMenuConstants';

interface DevicesFiltersFormProps {
    control: Control<any>;
    setValue: (name: string, value: any) => void;
}

const DevicesFiltersFormContent: React.FC<DevicesFiltersFormProps> = ({ control, setValue }) => {
    const { componentRegistry } = useComponentRegistry();

    return (
        <form className={'padding-left-20 padding-right-20 padding-top-5'}>
            <div id={SECTION_IDS.FAVORITES}>
                <FavoritesSection componentRegistry={componentRegistry}/>
            </div>
            <div id={SECTION_IDS.DEVICE_FILTERS}>
                <DeviceFiltersSection control={control} />
            </div>
            <div id={SECTION_IDS.STATUS_FILTERS}>
                <StatusFiltersSection control={control} />
            </div>
            <div id={SECTION_IDS.SOFTWARE_FILTERS}>
                <SoftwareFilterSection control={control} setValue={setValue} />
            </div>
            <div id={SECTION_IDS.INCLUDE_DEVICES}>
                <IncludeDevicesSection control={control}/>
            </div>
            <div id={SECTION_IDS.EXCLUDE_DEVICES}>
                <ExcludeDevicesSection control={control}/>
            </div>
            <div id={SECTION_IDS.OTHER_FILTERS}>
                <OtherFiltersSection control={control} />
            </div>
        </form>
    );
};

const DevicesFiltersForm: React.FC<DevicesFiltersFormProps> = ({ control, setValue }) => {
    return (
        <ComponentRegistryProvider>
            <DevicesFiltersFormContent control={control} setValue={setValue} />
        </ComponentRegistryProvider>
    );
};

export default DevicesFiltersForm;
